module.exports = __webpack_public_path__ + "66d49a1ac9e5e51a4d0126c552699543.svg";